import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// reducer import
import customizationReducer from './customizationReducer';
import accountReducer from './accountReducer';

//-----------------------|| COMBINE REDUCER ||-----------------------//

const reducer = combineReducers({
    account: persistReducer(
        {
            key: 'account',
            storage,
            keyPrefix: 'admin-'
        },
        accountReducer
    ),
    customization: persistReducer(
        {
            key: 'customization',
            storage,
            keyPrefix: 'admin-'
        },
        customizationReducer
    )
});

export default reducer;
